module.exports = __webpack_public_path__ + "img/welcome-background.2058d2b7.svg";